function list(value){return Array.isArray(value)?value.map(String):[]}

/**
 * Client-side role data scoping used to keep dashboards/lists consistent with a role's configured scope.
 * Database Security Rules / callable functions must remain the authoritative security boundary.
 */
export function applyRoleDataScope(rows=[],profile={}){
  const scope=String(profile?.dataScope||'institute').toLowerCase();
  if(profile?.isSuperAdmin||scope==='institute'||scope==='all')return rows;
  const actorId=String(profile?.id||'');
  const teacherId=String(profile?.teacherId||'');
  const branchId=String(profile?.branchId||'');
  const assignedBatches=new Set([...list(profile?.assignedBatchIds),...list(profile?.batchIds)]);
  const assignedStudents=new Set([...list(profile?.assignedStudentIds),...list(profile?.studentIds)]);
  const own=row=>[row?.createdBy,row?.updatedBy,row?.userId,row?.ownerId,row?.actorId,row?.teacherId,row?.employeeUserId,row?.assignedTo].filter(Boolean).some(v=>String(v)===actorId||String(v)===teacherId);
  const branch=row=>!branchId||!row?.branchId||String(row.branchId)===branchId;
  const assigned=row=>{
    const markers=[];
    if(row?.batchId)markers.push(assignedBatches.has(String(row.batchId)));
    if(row?.studentId)markers.push(assignedStudents.has(String(row.studentId)));
    if(row?.teacherId&&teacherId)markers.push(String(row.teacherId)===teacherId);
    if(row?.assignedTeacherId&&teacherId)markers.push(String(row.assignedTeacherId)===teacherId);
    // Shared masters without an assignment marker remain readable if permission grants access.
    return markers.length?markers.some(Boolean):branch(row);
  };
  if(scope==='own')return rows.filter(own);
  if(scope==='branch')return rows.filter(branch);
  if(scope==='assigned')return rows.filter(assigned);
  return rows;
}
